import { QSetStatus, type SearchQSetsQuery } from '@exam-management/graphql';

export default function getQSetsDraftAndPublishedDetails(
  searchedQSets: SearchQSetsQuery['excSearchQSets']['qSets'],
) {
  const draftQSets = [];
  const publishedQSets = [];
  for (const qSet of searchedQSets) {
    if (qSet.status === QSetStatus.Draft) {
      draftQSets.push(qSet);
    } else if (qSet.status === QSetStatus.Published) {
      publishedQSets.push(qSet);
    }
  }
  return { draftQSets, publishedQSets };
}
